import * as React from 'react'
import { SVGProps } from 'react'

function LeagueDetailsIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props.width ?? 24}
      height={props.height ?? 24}
      fill="none"
      {...props}
    >
      <g
        stroke={props.color ?? '#fff'}
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M6 3h9l5 5v11a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2z" />

        <path d="M15 3v5h5" />

        <circle cx={12} cy={14} r={2.5} />
        <path d="M14.1 16.1 16 18" />
      </g>
    </svg>
  )
}

export default LeagueDetailsIcon
